export class SWIC11WinnerList {
    constructor(list) {
        this.$winnerList = $(list);
        if (this.$winnerList.data("needsExpand") == "True") {
            this.$expandButton = this.$winnerList.find(".expand-button");
            this.$expandSection = this.$winnerList.find(".expand-section");
            const self = this;
            this.$expandButton.click((e) => {
                e.preventDefault();
                self.$expandButton.hide();
                self.$expandSection.show();
            });
            if (this.$winnerList.data("expandSmallOnly") == "True") {
                if ($(window).width() >= 640) {
                    self.$expandButton.click();
                }
                $(window).resize(() => {
                    if ($(window).width() >= 640) {
                        self.$expandButton.click();
                    }
                    else if ($(window).width() < 640) {
                        self.$expandButton.show();
                        self.$expandSection.hide();
                    }
                });
            }
        }
    }
}
const c = {};
$(".swic11-winners-list").each((i, elem) => {
    c[i] = new SWIC11WinnerList(elem);
});
